import restApiDispatcher from "@/store/utils/api-dispatcher";
import { News, Category, Tag } from "@/models";

const getNews = (context, params) =>
  restApiDispatcher(context, {
    resource: News,
    storeKey: "news",
    loadingKey: "newsLoading",
    action: "index",
    metaKey: "meta",
    params
  });

const getLatestNews = (context, params) =>
  restApiDispatcher(context, {
    resource: News,
    storeKey: "latestNews",
    loadingKey: "latestNewsLoading",
    action: "index",
    params
  });

const getSingleNews = (context, params) =>
  restApiDispatcher(context, {
    resource: News,
    storeKey: "singleNews",
    loadingKey: "singleNewsLoading",
    action: "show",
    commitType: "wrappedShow",
    params
  });

const getCategories = (context, params) =>
  restApiDispatcher(context, {
    resource: Category,
    storeKey: "categories",
    loadingKey: "categoriesLoading",
    action: "index",
    commitType: "indexUnwrapped",
    params
  });

const getTags = (context, params) =>
  restApiDispatcher(context, {
    resource: Tag,
    storeKey: "tags",
    loadingKey: "tagsLoading",
    action: "index",
    commitType: "indexUnwrapped",
    params
  });

export default {
  getNews,
  getSingleNews,
  getCategories,
  getTags,
  getLatestNews
};
